/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const footer_link_title = document.querySelectorAll('.Footer__Block.Footer__Block--links h2');

for (let i = 0; i < footer_link_title.length; i++) {
  footer_link_title[i].addEventListener("click", function(event) {
    let style = window.getComputedStyle(event.target, '::before');
    if (style.getPropertyValue('position') == "absolute") {
//       const footer_link = document.querySelectorAll('.Footer__Block.Footer__Block--links');
//       for (let j = 0; j < footer_link.length; j++) {
//         footer_link[j].classList.remove("mystyle");
//       }
      event.target.parentElement.classList.toggle("collapsed");
    }

  });
}

// document.querySelectorAll('.Footer__Block.Footer__Block--links h2').addEventListener('click', function(event) {
//   console.log(event.target);
//   let style = window.getComputedStyle(event.target, '::before');
//   console.log(style);
//   console.log(style.getPropertyValue('position'));
//   if (style.getPropertyValue('position') == "absolute") {
//     event.target.classList.toggle("collapsed");
//   }
   
// });


$(function(){
  $('.FitComparison__ImageWrapper').slick({
    infinite: true,
    fade: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  $(".FitComparison .fit-list li").click(function(){
    $(".FitComparison .fit-list li").removeClass("active");
    $(this).addClass("active");
    var i = $(this).data("index");
    $('.FitComparison__ImageWrapper').slick('slickGoTo', i);
  });

  $('.FitComparison__ImageWrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.FitComparison .fit-list li').removeClass('active');
    $('.FitComparison .fit-list li[data-index='+nextSlide+']').addClass('active');
  });
});

$(document).ready(function(){
    var x = $("input[name='option-0']:checked").val();
    $("#product-select-7256779784382 option").each(function(){
      var v = $(this).text();
      var value = $(this).data("size");
      if(v.indexOf(x) != -1){
        if($(this).data("available") == 'soldout'){
          $(".SizeSwatch-"+value).addClass("soldout");
        }else{
          $(".SizeSwatch-"+value).removeClass("soldout");
        }
      }
    });
  
  $(".ColorSwatchList .HorizontalList__Item").click(function(){
    var x = $("input[name='option-0']:checked").val();
    $("#product-select-7256779784382 option").each(function(){
      var v = $(this).text();
      var value = $(this).data("size");
      if(v.indexOf(x) != -1){
        if($(this).data("available") == 'soldout'){
          $(".SizeSwatch-"+value).addClass("soldout");
        }else{
          $(".SizeSwatch-"+value).removeClass("soldout");
        }
      }
    });
  });
});

$(document).ready(function() {
  var w = $(".SizeSwatchList").width();
  $(".webyzeProductColors").css("min-width", w+"px");
});
$(window).resize(function() {
  var w = $(".SizeSwatchList").width();
  $(".webyzeProductColors").css("min-width", w+"px");
});

$(document).ready(function() {
  // $(".Product__Tabs .Collapsible:last-child .Collapsible__Button").trigger("click");
});

// fix header sticky overlay issue
$(window).on("load resize scroll", function(){
  if($("#shopify-section-header").css("position") == "sticky") { 
    if($("#fsb_container")) {
      if($("#shopify-section-header #fsb_container").length > 0) {
      } else {
        $("#shopify-section-header").css("top", $("#fsb_container").height()); 
      }
    }
  }
})